import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';
import Slider from "../components/Slider";

$(() => {
    detailsFix.init();
});

const detailsFix = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');

        if( ! (this.$details[0] && this.params.objectGroupId === "1" && +this.$booking.attr('data-dynamicpackage') === 0)) {
            return;
        }

        if(! $('[data-isFixDepartures]').attr('data-isFixDepartures') || $('[data-isBookingCombined]').attr('data-isBookingCombined')) {
            return;
        }

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }

        if(this.params.guests) {
            $('[name=guests]').val(this.params.guests);
            $('.input-guests')[0]._inputGuests.elemChange($('.input-guests')[0]._inputGuests);
        }

        this.initDepartureCalendar();
        this.setDefaultDeparture();
        this.setActiveDeparture();

        if(this.params.guests) {
            $('[name=guests]').each((index, elem) => {
                $(elem).val(this.params.guests);

                let guests = this.params.guests.split(',');
                let i = 1;
                for (let index = 2; index < guests.length; index++) {
                    if(guests[index]) {
                        $('[name=child-age-'  + i + ']').val(guests[index]);
                    }
                    i++;
                }
            });
        }

        this.getCalculation();

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $('.departure').on('click', e => {
            $('.departure').removeClass('active');

            const $target = $(e.currentTarget);
            $target.addClass('active');

            this.params.dateFrom = $target.attr('data-datefrom');
            this.params.dateTo = $target.attr('data-dateto');

            $('[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']').addClass('active');
            //this.printDates();
            functions.setUrlData({'dateFrom': this.params.dateFrom, 'dateTo': this.params.dateTo, 'guests': this.params.guests }, true, true);
        });

        $('[name=guests]').on('change', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            //this.params.unitId = $target.attr('data-unitid');
            this.params.guests = $target.val();

            functions.setUrlData({'dateFrom': this.params.dateFrom, 'dateTo': this.params.dateTo, 'guests': this.params.guests }, true, true);
            //this.getCalculation();
        });

        $(window).on('hashchange', e => {
            this.getParams();

            this.setDeparture();
            this.setGuestsInstances();
            (! this.params.guests || ! this.params.dateFrom) && this.setUnitRates();

            this.setActiveDeparture();

            this.printDates();
            this.getCalculation(this.params);
        });
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    initDepartureCalendar() {
        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('.keen-slider__slide').length;
            const perView = 7;
            
            let slidesPerView = length < perView ? length : perView;

            if(length < perView) {
                //$('.booking-calendar-wrapper').addClass('col-lg-' + (slidesPerView + 3));
                //$('.booking-calendar-wrapper').addClass('mx-auto');
            }
    
            this.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                arrows: functions.isMobile() || length > slidesPerView,
                slides: {
                    perView: slidesPerView,
                    spacing: 0,
                },
                breakpoints: {
                    '(min-width: 993px) and (max-width: 1360px)': {
                        controls: true,
                        arrows: length > 5,
                        //centered: true,
                        slides: {
                            perView: 5,
                        },
                    },
                    '(min-width: 577px) and (max-width: 992px)': {
                        controls: true,
                        arrows: length > 4,
                        //centered: true,
                        slides: {
                            perView: 4,
                        },
                    },
                    '(max-width: 576px)': {
                        controls: true,
                        arrows: length > 2,
                        //centered: true,
                        slides: {
                            perView: 2,
                        },
                    },
                },
                detailsChanged: (s) => {
                    $('.booking-calendar-wrapper').find('[data-dir="prev"]').toggleClass('invisible', s.track.details.rel == 0);
                }
            });
        }
    },
    setDefaultDeparture() {
        this.params.dateFrom = ! this.params.dateFrom ? $('[data-datefrom]').attr('data-datefrom') : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo ? $('[data-datefrom=' + this.params.dateFrom + ']').attr('data-dateto') : this.params.dateTo;
        this.params.guests = $('[name=guests]').val(); 

        let $departureItem = $('[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']');
        
        if (! $departureItem.length) {
            let closestDateFrom, closestDateTo = null;

            $('.departure[data-datefrom]').each((i, elem) => {
                const $elem = $(elem);
                const dateFrom = $elem.attr('data-datefrom');
                const dateTo = $elem.attr('data-dateto');

                if (closestDateFrom) return;

                if (Date.parse(dateFrom) >= Date.parse(this.params.dateFrom)) {
                    closestDateFrom = dateFrom;
                    closestDateTo = dateTo;
                    $departureItem = $elem;
                }
            });

            if ( ! closestDateFrom) {
                $($('.departure[data-datefrom]').get().reverse()).each((i, elem) => { 
                    const $elem = $(elem);
                    const dateFrom = $elem.attr('data-datefrom');
                    const dateTo = $elem.attr('data-dateto');

                    if (closestDateFrom) return;

                    if (Date.parse(dateFrom) <= Date.parse(this.params.dateFrom)) {
                        closestDateFrom = dateFrom;
                        closestDateTo = dateTo;
                        $departureItem = $elem;
                    }
                });
            }

            this.params.dateFrom = closestDateFrom;
            this.params.dateTo = closestDateTo;
        }

        $departureItem.addClass('active');
        functions.setUrlData({'dateFrom': this.params.dateFrom, 'dateTo': this.params.dateTo, 'guests': this.params.guests }, true, true);

        this.slider.instance.slides.forEach((slide, index) => {
            const $slide = $(slide);

            if($slide.find('.departure.active').length) {
                let slideIndex = index;
                const perView = this.slider.instance.options.slides.perView;
                const slidesLength = this.slider.instance.slides.length;
                const lastIndex = slidesLength - 1;

                if (slideIndex + perView >= lastIndex) {
                    const indexDiff = slideIndex === lastIndex ? 1 : lastIndex - slideIndex;
                    this.slider.instance.moveToIdx(slideIndex - (perView - indexDiff));
                } else if (slideIndex > perView) {
                    this.slider.instance.moveToIdx(slideIndex);
                }
            }
        });

        this.printDates();
    },
    setDeparture() {
        if(this.params.dateFrom) {
            $('.departure').removeClass('active');
            //$('.departure-sm').removeClass('active');
            this.params.dateTo = ! this.params.dateTo ? $('[data-datefrom=' + this.params.dateFrom + ']').attr('data-dateto') : this.params.dateTo;

            $('[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']').addClass('active');

            //this.printDates();
        } else {
            this.setDefaultDeparture();
        }
    },
    setGuestsInstances() {
        const $departure = $('.departure[data-datefrom=' + this.params.dateFrom + ']');
        let maxPersonsUnits = $departure.attr('data-maxPersonsUnits') ? JSON.parse($departure.attr('data-maxPersonsUnits')) : null;
        
        if(maxPersonsUnits) {
            Object.entries(maxPersonsUnits).forEach(item => {
                const unitId = item[0];
                const quantity = item[1];
    
                $('.input-guests[data-unitid="' + unitId + '"]').each((i, elem) => {
                    const instance = elem._inputGuests; 
                    instance.max = quantity ? quantity : instance.max;
                    instance.checkUpdateBtns(instance, 'adults');
                });
            });
        }
    },
    setUnitRates() {
        if(this.params.dateFrom) {
            this.loader();

            setTimeout(() => {
                const $departure = $('.departure[data-datefrom=' + this.params.dateFrom + '][data-rates]');
                const rates = $departure.attr('data-rates') ? JSON.parse($departure.attr('data-rates')) : null;

                let excludedUnits = [];

                $('.unit').each((index, elem) => {
                    const unitIds = Object.keys(rates);
                    const unitId = $(elem).attr('data-unitid');

                    ! unitIds.includes(unitId) && excludedUnits.push(unitId);
                });

                if(excludedUnits.length) {
                    excludedUnits.forEach(unitId => {
                        const $unit = $('.unit[data-unitid="' + unitId + '"]');
                        $unit.find('.price-wrapper').addClass('d-none');
                        $unit.find('.badge-discount').addClass('d-none');
                        $unit.find('.add-to-cart').addClass('d-none');
                        $unit.find('.btn-request').removeClass('d-none');
                    });
                }

                $('.unit').attr('style', 'order: 10000');
                $('.unit').find('.price-from-label').addClass('d-none');

                Object.entries(rates).forEach(item => {
                    const unitId = item[0];
                    const rate = item[1];
    
                    const $unit = $('.unit[data-unitid="' + unitId + '"]');
    
                    $unit.find('.price-wrapper').removeClass('d-none');
                    $unit.find('.badge-discount').removeClass('d-none');
                    $unit.find('.add-to-cart').removeClass('d-none');
                    $unit.find('.btn-request').addClass('d-none');

                    let priceOld = rate.priceWithDiscount ? rate.price : false;
                    $unit.find('.price-old').text(rate.priceWithDiscount ? rate.price : '');
                    $unit.find('.price').text(rate.priceWithDiscount ? rate.priceWithDiscount : rate.price);
                    priceOld ? $unit.find('.price').addClass('text-danger') : $unit.find('.price').removeClass('text-danger');
                    //$unit.find('.price').toggleClass('text-danger', priceOld);
    
                    //$unit.find('.fm-discount').toggleClass('d-none', ! rate.discountTitle);
                    //$unit.find('.fm-discount-title').text(rate.discountTitle ? rate.discountTitle : '');
                    //$unit.find('.fm-discount-valid-until').toggleClass('d-none', ! rate.validUntil);
                    //$unit.find('.fm-discount-valid-until-date').text(rate.validUntil ? rate.validUntil : '');

                    let price = rate.priceWithDiscount ? rate.priceWithDiscount : rate.price;
                    price = +price.replace('€ ', '');

                    $unit.attr('style', 'order: ' + price);

                    $unit.find('.price-from-label').removeClass('d-none');
                });
            }, 0); // 800
        } else {
            $('.unit').find('.add-to-cart').addClass('d-none');
            $('.unit').find('.unit-price').addClass('d-none');
            $('.unit').find('.btn-request').removeClass('d-none');
            $('.details-cart').addClass('d-none');
        }
    },
    loader($target = null) {
        /*$('.units').addClass('fade');
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 600);
        setTimeout(() => {
            $('.units').removeClass('fade');
        }, 800);*/
    },
    printDates() {
        $('.date-from').text(functions.formatDate(this.params.dateFrom));
        $('.date-to').text(functions.formatDate(this.params.dateTo));
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        const calculation = details.getCalculation(cParams);

        if(calculation) {
            details.unitsSpinner();
            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                }).fail(error => {
                console.log(error);
            });
        } else {

            this.setUnitRates();

            //$('.block-no-dates').removeClass('d-none');
            //$('.block-discount').removeClass('d-none');
            //$('.block-loading').addClass('d-none');
        }

        //$('.block-totals-per-service').addClass('d-none');
        //$('.block-booking').addClass('d-none');
        //$('.block-error-msg').addClass('d-none');
    },
    calculationDone(response, params) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');
                const $addToCart = $unit.find('.add-to-cart');
                const isBookable = details.isBookable(unitData);
                
                if (isBookable) {
                    const unitCalc = unitData.calc;
                    const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                    const calcItems = unitCalc.items;

                    let priceOld = 0.00;
                    let discountTitle = null;

                    calcItems.forEach(item => {
                        // popust za djecu ne ulazi u prikaz discount cijene
                        if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                            priceOld += item.itemTotal;
                        }
                        if (item.itemType == 'discount') {
                            discountTitle = item.itemTitle;
                            if (item.data && item.data.text) {
                                discountTitle = item.data.text;
                            }
                        }
                    });

                    let hasDiscount = priceOld && priceOld != unitCalc.total ? priceOld : null;

                    const totalOld = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                    $unit.find('.price').html(total);

                    if (hasDiscount) {
                        priceOld && $unit.find('.price-old').html(totalOld);
                        discountTitle && $unit.find('.badge-discount').html(discountTitle);
                        discountTitle && $unit.find('.badge-discount').removeClass('d-none');
                    } else {
                        $unit.find('.price-old').html('');
                        $unit.find('.badge-discount').addClass('d-none');
                    }

                    $unit.prop('style', 'order: ' + Math.round(unitCalc.total) + ';');

                    $addToCart.attr('data-unitcarttotal', unitCalc.total);
                    $addToCart.attr('data-unitcarttotalold', priceOld);
                    $addToCart.attr('data-currencysymbol', unitCalc.currencySymbol);

                    $addToCart.attr('data-datefrom', detailsFix.params.dateFrom);
                    $addToCart.attr('data-dateto', detailsFix.params.dateTo);
                    $addToCart.attr('data-guests', detailsFix.params.guests);
                } else {
                    $unit.prop('style', 'order: 100000;');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable);
                $unit.find('.unit-error-message').text(error);

                $unit.find('.rate-container').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);

                $unit.find('.price-from-label').toggleClass('d-none', isBookable);
                $unit.find('.total-label').toggleClass('d-none', ! isBookable);

            });

            if(this.$cart.length) {
                const $btnBooking = $('.btn-booking');

                $btnBooking.on('click', e => {
                    e.preventDefault();
                    let cartData = [];

                    this.cart.cartItems.forEach(item => {
                        item = JSON.parse(item);
                        cartData.push({
                            'unitId': item.unitId,
                            'dateFrom': item.dateFrom,
                            'dateTo': item.dateTo,
                            'aDateFrom': item.aDateFrom,
                            'aDateTo': item.aDateTo,
                            'guests': item.guests,
                            'serviceCode': item.serviceCode,
                            'serviceId': item.serviceId,
                            'pricelistId': params.pricelistId,
                            'dynamicPackage': 0,
                        });
                    });
                    let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=0';

                    if(this.cart.cartItems.length) {
                        location = url;
                    } else {
                        $('#detailsCartModal').modal('show');
                        setTimeout(() => {
                            $('#detailsCartModal').modal('hide');
                        }, 2500);
                    }
                });
            } else {
                $('.btn-book-one-unit').on('click', e => {
                    const $target = $(e.currentTarget); 
                    let cartData = [
                        {
                            'unitId': $target.attr('data-unitId'),
                            'dateFrom': detailsFix.params.dateFrom,
                            'dateTo': detailsFix.params.dateTo,
                            'guests': detailsFix.params.guests,
                            'serviceCode': detailsFix.params.serviceCode,
                            //'dynamicPackage': 0,
                        }
                    ];

                    location = $target.attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true'; // &dynamicPackage=0
                });
            }
        }
    },
    setActiveDeparture() {
        if (this.params.dateFrom) {
            const $departure = $('.departure[data-dateFrom="' + this.params.dateFrom + '"]');
            $departure.addClass('active');

            const dateFrom = new Date(this.params.dateFrom);
            const dateTo = new Date(this.params.dateTo);
            const diffInMs = dateTo.getTime() - dateFrom.getTime();
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            const $departureSelection = $('.departure-selection');
            $departureSelection.find('.departure-dateFrom').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));
            $departureSelection.find('.departure-duration').text(diffInDays + ' noćenja');

            $('.accordion-summary .departure-dateFrom').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));
        }

        if (this.params.guests) {
            let guests = this.params.guests.split(',');
            $('.details-cart').find('.departure-guests').html(`
                ${ guests[0] } odrasli${ +guests[1] ? ', ' + guests[1] + ( +guests[1] == 1 ? ' dete' : ' dece') : ''}
            `);
        } else {
            $('.details-cart').find('.departure-guests').html(`
                <a href="" data-scroll-to="#booking,120">Odaberite broj gosta</a>
            `);
        }
    }
};